<template>
  <v-app app>
    <router-view/>
    <common-progress
            :is-show="loadingStatus['isShow']"
    />
    <common-dialog
            :isShow="snackbar['isShow']"
            :result="snackbar['result']"
    />

    <chrome-alert :dialog="chromeAlert['dialog']" />

    <!-- footer -->
<!--    <v-footer app color="grey darken-3" dark>-->
<!--      <span>&copy; {{ new Date().getFullYear() }} AshLab</span>-->
<!--    </v-footer>-->

  </v-app>
</template>

<script>
  import CommonDialog from '@/components/common/CommonDialog'
  import CommonProgress from "@/components/common/CommonProgress";
  import ChromeAlert from "@/components/common/ChromeAlert";
  import sessionManagerKey from "./constant/keyManager";


  export default {
    components: {
      CommonProgress,
      CommonDialog,
      ChromeAlert,
    },
    name: "App",
    data() {
      return {
        snackbar: {
          isShow : false,
          result : ''
        },
        delSnackbar: {
          alert : false,
        },
        loadingStatus: {
          isShow : false,
        },
        chromeAlert: {
          dialog : false
        }
      }

    },
    created () {
      // if (getCookie('x-access-token') !== null) {
      //     this.$http.defaults.headers['x-access-token'] = getCookie('x-access-token')
      // }
      this.$eventBus.$on('showDialog', this.showDialog)
      this.$eventBus.$on('startLoading', this.startLoading)
      this.$eventBus.$on('endLoading', this.endLoading)
    },
    watch: {
      '$route' () {
        // console.log(sessionStorage.getItem('admin_seq'))
        if (this.$router.currentRoute.name != 'login') {

          if (this.$router.currentRoute.name != 'reg_admin'){
            if (sessionStorage.getItem(sessionManagerKey.userSeq) == null) {
              this.$router.push({name : 'login'})
            }
          }

        }
        this.checkBrowser()
      },

    },

    methods: {
      showDialog(data) {
        this.snackbar['isShow'] = true
        this.snackbar['result'] = data['result']
        setTimeout(() => {
          this.snackbar['isShow'] = false
        }, 5000)
      },
      startLoading(){
        this.loadingStatus['isShow'] = true
      },
      endLoading(){
        this.loadingStatus['isShow'] = false
      },
      async checkBrowser() {
        if (navigator.userAgent.indexOf('Trident') != -1) {
          // console.log('false')
          this.$router.push({name: 'login'})
          this.chromeAlert['dialog'] = true
        }


        // userAgent = window.navigator.userAgent;
        // isChrome = userAgent.indexOf('Chrome');
        // isChromeMobile = userAgent.indexOf('CriOS');
        // isSamsungBrowser = userAgent.indexOf('SamsungBrowser');
        // isWindows = userAgent.indexOf('Windows NT');
        // isEdge = userAgent.indexOf('Edge');
        // isIE = userAgent.indexOf('Trident');
      }
      // logout () {
      //     console.log('logout')
      //     console.log(sessionStorage.getItem('admin_seq'))
      //     sessionStorage.setItem(0, 'admin_seq')
      //     this.$router.push({ name: 'login' })
      // },
    },
  }
</script>
